export default "__VITE_ASSET__f2394acf__"